import { useLocation, useOutletContext } from 'react-router-dom';
import { Container, Paper, Box, Tabs, Tab, Button, Grid, Divider, lighten, useTheme } from '@mui/material';
import UserList from './userList';
import { connect, useDispatch } from 'react-redux';
import { userManagementActions } from '../../store/reducers/user-management';
import { DEFAULT_ROLES } from '../../utils/user-management';
import { useEffect, useLayoutEffect, useState } from 'react';
import { userRoleActions } from '../../store/reducers/user-role';

import { ReactComponent as PersonIcon } from '../../assets/icons/main/person-icon.svg';
import CardComponent from '../../components/Card';
import Styles from '../../theme/commonCss/Styles';
import { UserStatusCounts } from '../../store/models/user-management';
import { get } from 'lodash';
import { useAuth } from 'react-oidc-context';
import UserRole from './userRole';
import { palette } from '../../theme/palette';
import { ReactComponent as DeleteIcon } from '../../assets/icons/main/delete-icon.svg';
import { ReactComponent as PlusCircleIcon } from '../../assets/icons/main/plus-circle-icon.svg';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from '../../utils/table-utils';

interface AccessTypes {
  all: boolean;
  read: boolean;
  create: boolean;
  update: boolean;
  delete: boolean;
  approver: boolean;
}

interface UseCaseTypes {
  userList: any;
  userListTotalCount: number;
  enabledUsers: number;
  disabledUsers: number;
  userMgmtSelectedTab: number;
  userAccess: {
    userList: AccessTypes;
    userRole: AccessTypes;
  };
}

// const userStatusCounts: UserStatusCounts = {
//   totalUsers: 0,
//   enabledUsers: 0,
//   disabledUsers: 0,
// };



const UserManagement = ({
  userMgmtSelectedTab,
  userList,
  userListTotalCount,
  enabledUsers,
  disabledUsers,
  userAccess,
}: UseCaseTypes) => {
  const themeData: any = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});

  const dispatch = useDispatch();
  const auth: any = useAuth();

  // const [userStatusCount, setUserStatusCount] = useState<UserStatusCounts>(userStatusCounts);
  // const [usersList, setUsersList] = useState([]);
  // const [allUsersRoles, setAllUsersRoles] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [addPopupOpen, setAddPopupOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedRole, setSelectedRole] = useState('');
  const [userDetails, setUserDetails] = useState({ username: '', password: '' });
  const [showUserDetails, setShowUserDetails] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [userIds, setUserIds] = useState<any>([]);
  const [roleIds, setRoleIds] = useState<any>([]);
  const location = useLocation();
  const persistedTabValue = get(location, 'state.persistTabValue', false);

  const authUserEmail = get(auth, 'user.profile.email', '');

  const handleTabChange = (e: any, value: any) => {
    dispatch(userManagementActions.userMgmtTabChange(value));
  };

  // useLayoutEffect(() => {
  //   if (!persistedTabValue) {
  //     dispatch(userManagementActions.userMgmtTabChange(0));
  //   }
  // }, [persistedTabValue]);

  useEffect(() => {
    // if (userAccess.userList.read) {
    //   dispatch(userManagementActions.getUserList(''));
    // }
    // if (userAccess.userRole.read) {
    //   dispatch(userRoleActions.getRoleList({ limit: DEFAULT_PAGE_SIZE, page: DEFAULT_PAGE_NUMBER }));
    // }
    if (!userAccess.userList.read && userAccess.userRole.read) {
      dispatch(userManagementActions.userMgmtTabChange(1));
    }
  }, [userAccess.userList.read, userAccess.userRole.read]);

  // useEffect(() => {
  //   if (userList.length) {
  //     // const filteredRows = userList
  //     //   .filter((user: any) => user.email !== authUserEmail)
  //     //   .map((users: any) => ({
  //     //     ...users,
  //     //     name: `${users.firstName} ${users.lastName}`,
  //     //   }));

  //     // const usersCount = userList.reduce(
  //     //   (acc: any, user: any) => {
  //     //     if (user.enabled) {
  //     //       acc.enabledUsers += 1;
  //     //     } else {
  //     //       acc.disabledUsers += 1;
  //     //     }
  //     //     acc.totalUsers += 1;
  //     //     return acc;
  //     //   },
  //     //   { totalUsers: 0, enabledUsers: 0, disabledUsers: 0 }
  //     // );

  //     const allRoles = userList.reduce((acc: any, user: any) => {
  //       const roles = user.roles.map((role: any) => role.name);
  //       return Array.from(new Set([...acc, ...roles]));
  //     }, []);

  //     // setUserStatusCount(usersCount);
  //     // setUsersList(filteredRows);
  //     setAllUsersRoles(allRoles);
  //   }
  // }, [authUserEmail, JSON.stringify(userList)]);

  const handleAdd = () => {
    setAddPopupOpen(true);
    // if (userMgmtSelectedTab === 0) {
    //   dispatch(userRoleActions.getRoleList());
    // }
  };

  const deleteUsersAction = () => {
    if (userMgmtSelectedTab === 0) {
      setConfirmPopup(true);
      setUserIds(selectedRows);
    } else {
      setConfirmPopup(true);
      setRoleIds(selectedRows);
    }
  };

  return (
    <>
      <Box sx={Styles.totalCountCardContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <CardComponent title={'Enabled Users'} number={enabledUsers} icon={<PersonIcon />} color='#0EAB4E' />
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <CardComponent title={'Disabled Users'} number={disabledUsers} icon={<PersonIcon />} color='#51648F' />
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <CardComponent title={'Total Users'} number={userListTotalCount} icon={<PersonIcon />} color='#537EFF' />
          </Grid>
        </Grid>
      </Box>
      <Container
        maxWidth={false}
        disableGutters
        sx={{ boxShadow: '0px 0px 14px 0px rgba(0, 0, 0, 0.02)', borderRadius: '18px' }}
      >
        <Paper
          sx={{
            margin: 'auto',
            boxShadow: '0px 0px 14px 0px #0000000D',
            borderRadius: '18px',
            border: `1px solid  ${themeData.palette.customBorderColor.main}`,
            // backgroundColor: lighten(themeData.palette.background.default, 0.3),
            // backgroundColor: lighten(themeData.palette.background.default, 0.2),//for lighten theme
            backgroundColor: themeMode.isLightBG
              ? lighten(themeData.palette.background.default, 0.2)
              : lighten(themeData.palette.background.default, 0.08),
          }}
        >
          <Grid
            container
            sx={{
              paddingInline: 3,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Tabs value={userMgmtSelectedTab} onChange={handleTabChange}
            TabIndicatorProps={{ style: { backgroundColor: 'primary', height: '3px' } }}
>
              <Tab label='User List' disabled={!userAccess.userList.read} />
              <Tab label='User Role' disabled={!userAccess.userRole.read} />
            </Tabs>
            <Grid
              sx={{
                '@media (min-width:300px) and (max-width:1365px)': {
                  paddingTop: '16px',
                  paddingBottom: '16px',
                },
              }}
            >
              {userAccess.userList.create && selectedRows.length > 0 && (
                <Button variant='outlined' sx={{ marginRight: '16px' }} onClick={deleteUsersAction}>
                  <DeleteIcon style={{ marginRight: 1 }} />
                  Delete Selected
                </Button>
              )}
              <Button
                variant='contained'
                onClick={handleAdd}
                disabled={userMgmtSelectedTab === 0 ? !userAccess.userList.create : !userAccess.userRole.create}
              >
                {(userMgmtSelectedTab === 0 ? !userAccess.userList.create : !userAccess.userRole.create) ? (
                  <PlusCircleIcon
                    style={{
                      color: palette.disabledColor.contrastText,
                    }}
                  />
                ) : (
                  <PlusCircleIcon />
                )}
                Add New
              </Button>
            </Grid>
          </Grid>
          <Divider />

          {userMgmtSelectedTab === 0 && (
            <UserList
              setSelectedRows={setSelectedRows}
              selectedRows={selectedRows}
              setAddPopupOpen={setAddPopupOpen}
              addPopupOpen={addPopupOpen}
              setIsEdit={setIsEdit}
              isEdit={isEdit}
              selectedRole={selectedRole}
              setSelectedRole={setSelectedRole}
              userDetails={userDetails}
              setUserDetails={setUserDetails}
              showUserDetails={showUserDetails}
              setShowUserDetails={setShowUserDetails}
              confirmPopup={confirmPopup}
              setConfirmPopup={setConfirmPopup}
              userIds={userIds}
              setUserIds={setUserIds}
              userAccess={userAccess.userList}
            />
          )}
          {userMgmtSelectedTab === 1 && (
            <UserRole
              setAddPopupOpen={setAddPopupOpen}
              addPopupOpen={addPopupOpen}
              setRoleIds={setRoleIds}
              roleIds={roleIds}
              confirmPopup={confirmPopup}
              setConfirmPopup={setConfirmPopup}
              setSelectedRows={setSelectedRows}
              selectedRows={selectedRows}
              userAccess={userAccess.userRole}
              userListAccess={userAccess.userList}
            />
          )}
        </Paper>
      </Container>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  userMgmtSelectedTab: state.userManagement.userMgmtSelectedTab,
  userList: state.userManagement.userList,
  userListTotalCount: state.userManagement.userListTotalCount,
  enabledUsers: state.userManagement.enabledUsers,
  disabledUsers: state.userManagement.disabledUsers,
  userAccess: {
    userList: get(state, 'profile.userAccess.auth/users', {}),
    userRole: get(state, 'profile.userAccess.auth/roles', {}),
  },
});

export default connect(mapStateToProps)(UserManagement);
